import HistoryUtil from 'common/util/HistoryUtil';
import QueryUtil from 'common/util/QueryUtil';

export default () =>
	Component(
		$context => $context.select('.sorting-options'),
		$sorting => {
			const sort_trigger = $sorting.data('sort-trigger');
			const can_json = $sorting.data('can-json');

			function getSortUrl(sort, order) {
				const url = location.href;
				let params = QueryUtil.parse(url);

				const current_sort = QueryUtil.find(params, 'sort');
				if (current_sort && current_sort.value === sort) {
					const current_order = QueryUtil.find(params, 'order');
					order = current_order && current_order.value === 'asc' ? 'desc' : 'asc';
				}

				params.push({
					name: 'sort',
					value: sort
				});

				params.push({
					name: 'order',
					value: order
				});

				params = QueryUtil.uniqualize(params);

				return QueryUtil.build(params);
			}

			function sortItems(sort, order) {
				const url = getSortUrl(sort, order);

				$.get(url + '&_=_', function(html) {
					if (can_json) {
						try {
							const response = JSON.parse(html);

							if (response.data) {
								html = response.data;
							}
						} catch(e) { }
					}

					const $html = $(html);
					$sorting.html($html.find('.sorting-options').html());

					HistoryUtil.replaceState({}, '', url);

					if (sort_trigger) {
						$(document).trigger(sort_trigger, html);
					}

					Update($sorting);
				});
			}

			function replaceProducts() {
				$.get(window.location, function(html) {
					if (can_json) {
						try {
							const response = JSON.parse(html);

							if (response.data) {
								html = response.data;
							}
						} catch(e) { }
					}

					$(document).trigger('replace_products', html);
				})
			}

			$sorting.on('change', '.sorting-options__select', function() {
				const $option = $(this).find('option:selected');
				const order = $option.attr('data-sort-order');
				const type = $option.attr('data-sort-type');

				sortItems(type, order);
			});

			$sorting.on('click', '.sorting-options__option', function() {
				const $option = $(this);
				const order = $option.attr('data-sort-order');
				const type = $option.attr('data-sort-type');

				sortItems(type, order);
			});

			// $sorting.find('.toggler--d').on('change_value', function(e, args){
			// 	const $toggler = $(this);
			// 	const viewTypes = $toggler.data('types').split(',');
			// 	const viewType = viewTypes[args.val];
			// 	Cookies.set('product_view', viewType);
			// 	replaceProducts();
			// 	if( typeof yaCounter26476791 != 'undefined' ) {
			// 		yaCounter26476791.reachGoal('visual_sotr');
			// 	}
			// });
			// $sorting.find('.toggler--m').on('change_value', function(e, args){
			// 	const $toggler = $(this);
			// 	const viewTypes = $toggler.data('types').split(',');
			// 	const viewType = viewTypes[args.val];
			// 	Cookies.set('product_m-view', viewType);
			// 	replaceProducts();
			// 	if( typeof yaCounter26476791 != 'undefined' ) {
			// 		yaCounter26476791.reachGoal('visual_sotr');
			// 	}
			// });
		}
	);
